import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          Made by{' '}
          <a
            href="https://georgealexander.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
          >
            George Alexander
          </a>
        </p>
      </div>
    </footer>
  );
}
